"use client";
import { useHasHydrated } from "@/hooks/useHasHydrated/useHasHydrated";
import React from "react";
import { SearchAvailableRoomForm } from "../search-avaliable/SearchAvailableRoomForm";
import { SearchHotelMobile } from "../search-avaliable/SearchHotelMobile";

interface SpecifiedBannerProps {
  title?: string;
  subDetail?: string;
  className?: string;
  locale?: string;
}
/**
 * component SpecifiedBanner
 *
 * Displays a banner section for specific pages such as policy or legal pages.
 * Includes a localized title, subtitle, and search components.
 * Uses hydration check to prevent rendering mismatch issues in Next.js.
 */
const SpecifiedBanner: React.FC<SpecifiedBannerProps> = ({
  title = "",
  subDetail = "",
  className = "",
  locale = "",
}) => {
  /**
   * Ensures the component only renders after hydration on the client side.
   * Prevents mismatches between server-rendered and client-rendered content.
   */
  const hasHydrated = useHasHydrated();

  return (
    /**
     * Conditional rendering — component is rendered only after hydration is confirmed.
     */
    hasHydrated && (
      <div className={`flex w-full flex-col ${className}`}>
        {/**
         * Banner container
         * - Contains title, subtitle, and search components.
         * - Handles responsive layout and positioning.
         */}
        <div className="mb-8 w-full bg-[var(--fill-base-main)] md:relative md:mb-50">
          <div className="container mx-auto flex max-w-[980px] flex-col items-center justify-center py-4 md:relative md:h-[303px]">
            <div className="w-full text-center leading-relaxed md:mb-16 md:px-0">
              <div className="flex-1 px-2">
                <h1 className="text-[30px] font-[var(--font-semibold)] text-white md:text-[42px]">
                  {title ?? "お部屋を予約しませんか？"}
                </h1>
                <p className="text-xl text-white/80 md:text-3xl">
                  {subDetail ?? "最も安い「最低価格」で予約しませんか？"}
                </p>
              </div>
            </div>

            {/** Desktop search form (positioned absolutely at the bottom) */}
            <SearchHotelMobile locale={locale} />
            <div className="absolute -bottom-35 left-1/2 z-10 hidden w-full max-w-[890px] -translate-x-1/2 md:block">
              <SearchAvailableRoomForm isTopPage locale={locale} />
            </div>
          </div>
        </div>
      </div>
    )
  );
};

export default SpecifiedBanner;
